import { FC } from 'react';
import { Skeleton } from 'antd';
import * as Styled from './styles';
import { IS_DEFAULT_MODE } from 'constants/app/configs';

type NftPriceSummarySkeletonProps = {
  className?: string;
};

export const NftPriceSummarySkeleton: FC<NftPriceSummarySkeletonProps> = ({
  className
}) => {
  return (
    <Styled.NftPriceSummaryTable className={className}>
      <div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
      </div>
      <div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
      </div>
      {!IS_DEFAULT_MODE && (
        <div>
          <div>
            <Skeleton.Button
              active
              style={{ width: '50px', height: 20, margin: 0 }}
              shape="round"
            />
          </div>
          <div>
            <Skeleton.Button
              active
              style={{ width: '50px', height: 20, margin: 0 }}
              shape="round"
            />
          </div>
        </div>
      )}
      <div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
        <div>
          <Skeleton.Button
            active
            style={{ width: '50px', height: 20, margin: 0 }}
            shape="round"
          />
        </div>
      </div>
    </Styled.NftPriceSummaryTable>
  );
};
